import { Controller } from '@hotwired/stimulus';

/**
 * Drives Section 5 (Rückblicke und Historie).
 * Clicking the prev/next chips advances BOTH the photo and the stat tile
 * by one step, cycling around. Both have their own count — we wrap each
 * independently so a 3-photo / 4-stat list still pairs up sensibly.
 */
export default class extends Controller {
    static targets = ['photo', 'stat'];

    connect() {
        this.index = 0;
        this.render();
    }

    next() {
        this.index += 1;
        this.render();
    }

    prev() {
        this.index -= 1;
        this.render();
    }

    render() {
        if (this.hasPhotoTarget) {
            const n = this.photoTargets.length;
            const photoIndex = ((this.index % n) + n) % n;
            this.photoTargets.forEach((el, i) => {
                el.classList.toggle('is-active', i === photoIndex);
            });
        }

        if (this.hasStatTarget) {
            const n = this.statTargets.length;
            const statIndex = ((this.index % n) + n) % n;
            this.statTargets.forEach((el, i) => {
                el.classList.toggle('is-active', i === statIndex);
            });
        }
    }
}
